import { InternalCompany } from '@application/common/enums/internal-company';
export function useInvoiceEmailCount() {
    return Object.values(InternalCompany).length;
}
